import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import DataTableCard from '../../Components/Table/DataTableCard';

const ProgramList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null); // { message: '', type: 'success' }

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToast({
        message: location.state.toastMessage,
        type: location.state.toastType || 'success',
      });
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => setToast(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        setLoading(true);
        const result = await api.getAllProgram();
        setPrograms(result);
      } catch (error) {
        console.error('Error fetching programs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
  }, []);

  return (
    <div className="container-fluid p-0">
      <DataTableCard
        icon="bi-kanban"
        title="Daftar Program"
        subtitle="Kelola program dan batch yang ditawarkan."
        actions={
          <Link to="/program/add" className="btn btn-primary rounded-pill px-3">
            <i className="bi bi-plus-circle me-2"></i>Tambah Program
          </Link>
        }
      >
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light text-muted small text-uppercase fw-bold">
              <tr>
                <th className="ps-4 py-3 border-0">Program</th>
                <th className="border-0 py-3">Divisi</th>
                <th className="border-0 py-3">Deskripsi</th>
                <th className="border-0 py-3">Batch Ditawarkan</th>
                <th className="border-0 py-3 text-end pe-4">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, idx) => (
                  <tr key={idx} className="placeholder-glow">
                    <td className="ps-4 py-3"><span className="placeholder col-8 rounded"></span></td>
                    <td className="py-3"><span className="placeholder col-6 rounded"></span></td>
                    <td className="py-3"><span className="placeholder col-10 rounded"></span></td>
                    <td className="py-3"><span className="placeholder col-6 rounded"></span></td>
                    <td className="text-end pe-4 py-3"><span className="placeholder col-4 rounded"></span></td>
                  </tr>
                ))
              ) : programs.length > 0 ? (
                programs.map((p) => (
                  <tr
                    key={p.id}
                    className="cursor-pointer transition-all"
                    onClick={() => navigate(`/program/${p.id}`)}
                  >
                    <td className="ps-4 py-3">
                      <div className="fw-bold text-dark">
                        <i className="bi bi-briefcase-fill text-primary me-2"></i>
                        {p.name}
                      </div>
                    </td>
                    <td className="py-3">
                      <span className="small text-muted">
                        <i className="bi bi-diagram-3 me-1"></i>
                        {p.underDivision}
                      </span>
                    </td>
                    <td className="py-3">
                      <span
                        className="small text-secondary text-truncate d-inline-block"
                        style={{ maxWidth: '200px' }}
                      >
                        {p.description || <em>Tidak ada deskripsi.</em>}
                      </span>
                    </td>
                    <td className="py-3">
                      {p.offered.length > 0 ? (
                        <div className="d-flex flex-wrap gap-1">
                          {p.offered.map((o, i) => (
                            <span
                              key={i}
                              className={`badge bg-${o.statusOffered ? 'success' : 'secondary'} bg-opacity-10 text-${o.statusOffered ? 'success' : 'secondary'} rounded-pill px-3 py-2`}
                            >
                              Batch {o.batch}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted extra-small">-</span>
                      )}
                    </td>
                    <td className="py-3 text-end pe-4">
                      <button
                        className="btn btn-outline-primary btn-sm rounded-circle"
                        style={{ width: '32px', height: '32px' }}
                        title="Detail"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/program/${p.id}`);
                        }}
                      >
                        <i className="bi bi-eye-fill"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-5">
                    <div className="text-muted mb-3 opacity-25">
                      <i className="bi bi-inbox fs-1"></i>
                    </div>
                    <h6 className="fw-bold text-dark mb-1">Belum ada program</h6>
                    <p className="text-muted small mb-0">
                      Belum ada program yang terdaftar untuk saat ini.
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DataTableCard>

      {/* Bootstrap Toast Notification Container */}
      {toast && (
        <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1060 }}>
          <div
            className={`toast show align-items-center text-white bg-${toast.type === 'danger' ? 'danger' : 'success'} border-0 shadow-lg`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">
                <i className={`bi ${toast.type === 'danger' ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'} me-2`}></i>
                {toast.message}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setToast(null)}
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgramList;
